module.exports = __webpack_public_path__ + "static/media/border-torn-paper.846862f1.svg";